import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import store from "../store";
import Analytics from "../analytics";
import {getCustomerById, resetUserPassword, userLogin, userRegister} from "../api/user-api";
import {showQuoteSavedNotification} from "../bvcomponents/ui/successNotification";
import {saveQuote} from "../api/server-api";
import {getAnalyticsEcommerceValues} from "../analyticsEcommerceParams";
import {restorePaymentInfo} from "../actions/paymentFunctions";
import Misc from "./misc";
import {changeUserInfo, toggleUserPopup} from "../actions/actionFunctions";

export const loginButtonCommonClick = async (updateInputValidations, analyticsLabel) => {
  await updateInputValidations();
  const errors = store.getState().userState.userInfoErrors;
  if (Object.keys(errors).length && Object.keys(errors)
    .filter(key => key === "email" || key === "password")
    .some(key => errors[key] && errors[key].length)) {
    return false
  }
  loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  const {currency, value} = getAnalyticsEcommerceValues();
  Analytics.sendEcommerceEvent("generate_lead", {currency, value});

  const loginResponse = await userLogin();
  loaderDisable();
  return loginResponse
}

export const saveQuoteAfterSignIn = async () => {
  loaderEnable();
  const savedSuccess = await saveQuote({submit: true, showReceipt: false});
  if (savedSuccess) {
    showQuoteSavedNotification();
  }
  loaderDisable();
  return savedSuccess
}

export const registerButtonCommonClick = async (updateInputValidations, analyticsLabel, executeAfterRegisterIfUserExist) => {
  await updateInputValidations();
  const {userState} = store.getState();
  const errors = userState.userInfoErrors;
  if (Object.keys(errors).length && Object.keys(errors)
    .filter(key => key !== "password")
    .some(key => errors[key] && errors[key].length)) {
    return false
  }
  if (userState.userInfo) {
    store.dispatch(restorePaymentInfo({ // on register - fill in also shipping, why not
      shippingAddress: {
        address1: userState.userInfo.address1,
        address2: userState.userInfo.address2,
        fullName: userState.userInfo.firstName + " " + userState.userInfo.lastName,
        city: userState.userInfo.city,
        state: userState.userInfo.state,
        postal: userState.userInfo.postal,
      }
    }))
  }
  loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  const {currency, value} = getAnalyticsEcommerceValues();
  Analytics.sendEcommerceEvent("generate_lead", {currency, value});

  const registeredResponse = await userRegister({executeAfterRegisterIfUserExist});
  console.log("successfully registered", registeredResponse);
  loaderDisable();
  return registeredResponse
}

export const remindPasswordCommonClick = async (updateInputValidations, analyticsLabel) => {
  await updateInputValidations();
  const fullStore = store.getState();
  // const {language} = fullStore.serverState;
  // const {userInfo, userInfoErrors} = fullStore.userState;
  const {userInfoErrors} = fullStore.userState;

  if (userInfoErrors.email && userInfoErrors.email.length) {
    return false
  }
  // loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  await resetUserPassword();
  // loaderDisable();
}

export const getUpdatedUserInfoFromTheResponse = (newUserInfo, responseCustomer, onLoad = false) => {
  if (onLoad) {
    if (responseCustomer.email) {
      newUserInfo.email = responseCustomer.email;
    }
    if (responseCustomer.fullName) {
      newUserInfo.firstName = responseCustomer.fullName;
    }
  }
  if (responseCustomer.phone) {
    const oldCountry = responseCustomer.country || responseCustomer.shipping ? responseCustomer.shipping.country : "";
    const {phoneNumber, country} = Misc.getUserPhoneSplitted(responseCustomer.phone, oldCountry);
    newUserInfo.phoneNumber = phoneNumber;
    newUserInfo.phone = phoneNumber;
    if (country) {
      newUserInfo.country = country;
    }
  }
  if (responseCustomer.address) {
    ["address1", "address2", "postal", "city", "provence"].forEach(key => { // removed country, cause it is a string, and we keep object now
      if (responseCustomer.address[key]) {
        const realKey = (key === "provence") ? "state" : key;
        newUserInfo[realKey] = responseCustomer.address[key];
      }
    });
    store.dispatch(restorePaymentInfo({
      billingAddress: Misc.parseAddressResponseObject(responseCustomer.address), // always change
    }));
  }
  newUserInfo.shipping = responseCustomer.shipping;
  if (newUserInfo.shipping) {
    const alreadyAddedShipping = store.getState().paymentState.shippingAddress.address1;
    if (!alreadyAddedShipping) {
      // not always change. only if we didn't set custom
      store.dispatch(restorePaymentInfo({
        shippingAddress: Misc.parseAddressResponseObject(newUserInfo.shipping)
      }));
    }
  }

  return newUserInfo
}

export const tryToSetUserFromUrl = async (url) => {
  if (!url || !url.searchParams) {
    return
  }
  const userId = url.searchParams.get("u");
  if (!userId) {
    return
  }
  try {
    const customerId = +(userId.split("/")[0]);
    const responseCustomer = await getCustomerById({
      customerId,
    });
    if (!responseCustomer) {
      return
    }
    const newUserInfo = getUpdatedUserInfoFromTheResponse({}, responseCustomer, true);
    store.dispatch(changeUserInfo(newUserInfo));
    store.dispatch(toggleUserPopup({
      userIsLoggedIn: true,
      isPhoneNumberValidated: true
    }));
  } catch (e) {
    console.log("couldn't log in customer", userId);
  }
}

export const setDealerUserFromFabricator = (fabricatorData) => {
  const {userIsLoggedIn} = store.getState().userState;
  if (userIsLoggedIn) {
    return
  }
  try {
    const addressObject = Array.isArray(fabricatorData.addresses) && fabricatorData.addresses[0]
      ? fabricatorData.addresses[0]
      : {};
    let newUserInfo = getUpdatedUserInfoFromTheResponse({}, fabricatorData, true);
    newUserInfo = {
      ...newUserInfo,
      email: fabricatorData.contactEmail,
      password: "",
      firstName: fabricatorData.companyName || fabricatorData.name,
      postal: addressObject.postal || "",
      isNew: false,
      lastName: "",
      phone2: "",
      address1: addressObject.address1 || "",
      address2: addressObject.address2 || "",
      city: addressObject.city || "",
      provence: addressObject.provence || "",
      state: addressObject.state || "",
      // country: addressObject.country || "", // it should be an object, not a string!
    };
    // console.log("fab user", newUserInfo);
    store.dispatch(changeUserInfo(newUserInfo));
    store.dispatch(toggleUserPopup({
      userIsLoggedIn: true,
      isPhoneNumberValidated: true
    }));
  } catch (e) {
    console.log("couldn't log in fabricator", fabricatorData);
  }
}
